import { useEffect, useState } from "react";
import CuDropdown from "../../common_component/component/CuDropdown";
import CuSpinner from "../../common_component/component/CuSpinner";
import InputField from "../../common_component/component/InputField";
import "../css/MedicineDataForm.css";
import {
  useCreateItem,
  useSecureUpdateItem,
} from "../../_helper/actions/mutation/items";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { userRoleAtom } from "../../components/admin/setup/atom/Atom";
import { toast } from "react-toastify";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import CuSuggestionBox from "../../common_component/component/CuSuggestionBox";

const fields = [
  { id: 1, label: "Medicine Name", type: "text", required: true },
  { id: 2, label: "Generic Name", type: "text", required: true },
  { id: 3, label: "Dosage", type: "text", required: true },
  { id: 4, label: "Unit", type: "text", required: true },
  { id: 5, label: "When", type: "text", required: true },
  { id: 6, label: "Frequency", type: "text", required: true },
  // { id: 7, label: "Duration", type: "text", required: true },
  { id: 8, label: "Notes", type: "text", required: true },
  { id: 9, label: "Medicine Type", type: "text", required: true },
  // { id: 10, label: "Category", type: "text", required: true },
];

const MedicineDataForm = ({
  editData,
  handleCancel,
  handleEdit,
  selectedOption,
  mode,
}) => {
  const [formData, setFormData] = useState({
    medicine_name: "",
    generic_name: null,
    dosage: null,
    unit: null,
    when: null,
    frequency: null,
    // duration: "",
    notes: null,
    medicine_type: null,
    // category: null,
  });
  const [clinic] = useAtom(clinicAtom);
  const [doctorData] = useAtom(userRoleAtom);
  const [searchInput, setSearchInput] = useState({
    medicine_name: "",
    generic_name: "",
    dosage: "",
    unit: "",
    when: "",
    frequency: "",
    // duration: "",
    notes: "",
    medicine_type: "",
    // category: "",
  });
  // const [options, setOptions] = useState({
  //   generic_name: [],
  //   dosage: [],
  //   unit: [],
  //   when: [],
  //   frequency: [],
  //   duration: [],
  //   notes: [],
  //   medicine_type: [],
  //   category: [],
  // });

  //(searchInput);
  const postMutation = useCreateItem(selectedOption?.offset);
  const updateMutation = useSecureUpdateItem(selectedOption?.offset);

  const { data: medicineName } = useItemsFilter(
    ApiEndPoint.QP_CM_MEDICINE_DATA,
    `?action=getMedicineData&medicine_name=${searchInput?.medicine_name}`,
    searchInput?.medicine_name?.length > 0 ? true : false
  );

  const { data: genericName } = useItemsFilter(
    ApiEndPoint.QP_CM_GENERIC_NAME,
    `?action=getGenericName&frontend=True&clinic_id=${clinic?.id}&name__startswith=${searchInput?.generic_name}`,
    searchInput?.generic_name?.length > 0 ? true : false
  );
  const { data: dosage } = useItemsFilter(
    ApiEndPoint.QP_CM_DOSAGE,
    `?action=getDosages&frontend=True&clinic_id=${clinic?.id}&name__startswith=${searchInput?.dosage}`,
    searchInput?.dosage?.length > 0 ? true : false
  );
  const { data: unit } = useItemsFilter(
    ApiEndPoint.QP_CM_UNITS,
    `?action=getUnits&frontend=True&clinic_id=${clinic?.id}&name__startswith=${searchInput?.unit}`,
    searchInput?.unit?.length > 0 ? true : false
  );
  const { data: when } = useItemsFilter(
    ApiEndPoint.QP_CM_WHEN,
    `?action=getWhen&frontend=True&clinic_id=${clinic?.id}&name__startswith=${searchInput?.when}`,
    searchInput?.when?.length > 0 ? true : false
  );
  const { data: frequency } = useItemsFilter(
    ApiEndPoint.QP_CM_FREQUENCY,
    `?action=getFrequency&frontend=True&clinic_id=${clinic?.id}&name__startswith=${searchInput?.frequency}`,
    searchInput?.frequency?.length > 0 ? true : false
  );
  const { data: notes } = useItemsFilter(
    ApiEndPoint.QP_CM_NOTES,
    `?action=getNotes&frontend=True&clinic_id=${clinic?.id}&name__startswith=${searchInput?.notes}`,
    searchInput?.notes?.length > 0 ? true : false
  );
  const { data: medicine_type } = useItemsFilter(
    ApiEndPoint.QP_CM_MEDICINE_TYPE,
    `?action=getMedicineTypes&frontend=True&clinic_id=${clinic?.id}&name__startswith=${searchInput?.medicine_type}`,
    searchInput?.medicine_type?.length > 0 ? true : false
  );
  const options = {
    medicine_name: medicineName,
    generic_name: genericName,
    dosage: dosage,
    unit: unit,
    when: when,
    frequency: frequency,
    // duration: [],
    notes: notes,
    medicine_type: medicine_type,
    // category: [],
  };

  useEffect(() => {
    if (editData) {
      setFormData({
        id: editData?.id,
        medicine_name: editData?.medicine_name,
        generic_name: editData?.generic_name,
        dosage: editData?.dosage,
        unit: editData?.unit,
        when: editData?.when,
        frequency: editData?.frequency,
        // duration: editData?.duration,
        notes: editData?.notes,
        medicine_type: editData?.medicine_type,
        // category: editData?.category?.id,
      });
    }
  }, [editData]);

  console.log(formData);
  const handleChange = (val, label) => {
    if (label === "medicine_name") {
      setFormData((prev) => ({ ...prev, [label]: val }));
    } else {
      setFormData((prev) => ({ ...prev, [label]: { name: val } }));
    }
  };

  // const handleChange = (val, label) => {
  //   setFormData((prev) => ({ ...prev, [label]: { name: val } }));
  // };

  const clearAllSearch = () => {
    setSearchInput({
      medicine_name: "",
      generic_name: "",
      dosage: "",
      unit: "",
      when: "",
      frequency: "",
      // duration: "",
      notes: "",
      medicine_type: "",
      // category: "",
    });
  };

  const handleSelectOption = (val, label) => {
    //("Value--DATa", val, label);
    if (label === "medicine_name") {
      setFormData((prev) => ({ ...prev, [label]: val[label] }));
    } else {
      setFormData((prev) => ({ ...prev, [label]: val }));
    }
    clearAllSearch();
  };

  // const handleSelectOption = (val, label) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     [label]: { name: val.medicine_name || val },
  //   }));
  //   setSearchInput((prev) => ({ ...prev, [label]: "" }));
  // };

  const handleSearch = (val, label) => {
    //("value", val);
    setSearchInput({
      medicine_name: "",
      generic_name: "",
      dosage: "",
      unit: "",
      when: "",
      frequency: "",
      // duration: "",
      notes: "",
      medicine_type: "",
      // category: "",
      [label]: val,
    });
  };

  const handleSubmit = (e) => {
    const newObj = {};
    Object.keys(formData).forEach((key) => {
      console.log(key);
      if (key === "id") {
        newObj[key] = formData[key];
      } else if (key === "medicine_name") {
        newObj[key] = formData[key];
      } else {
        if (formData[key]?.id || formData[key]?.name) {
          newObj[key] = formData[key]?.id || formData[key]?.name;
        }
      }
    });

    e.preventDefault();
    let payload = {
      clinic_id: clinic?.id,
      // doctor_user: doctorData?.id,
      action: selectedOption?.postAction,
      frontend: "True",
      ...newObj,
    };

    // //("payload-------", payload);

    if (mode === "edit" && newObj?.id) {
      updateMutation.mutate(
        {
          id: newObj?.id,
          data: { ...payload, action: selectedOption?.editAction },
        },
        {
          onSuccess: () => handleCancel(),
          onError: () => toast.error("something went wrong"),
        }
      );
      return;
    }
    postMutation.mutate(payload, {
      onSuccess: () => handleCancel(),
      onError: () => toast.error("something went wrong"),
    });
  };

  //("form data----------", formData);
  return (
    <form onSubmit={handleSubmit} className="cu-setup-medicine-form">
      <div className="cu-setup-medicine-form-fields-container">
        {fields.map((field) => {
          return (
            <div className="cu-setup-medicine-form-input" key={field.id}>
              <label>{field.label}</label>
              <CuSuggestionBox
                value={
                  field.label !== "Medicine Name"
                    ? formData[field.label?.toLowerCase().replace(/\s+/g, "_")]
                        ?.name
                    : formData[field.label?.toLowerCase().replace(/\s+/g, "_")]
                }
                // value={
                //   formData[field.label?.toLowerCase().replace(/\s+/g, "_")]
                //     ?.name
                // }
                onChange={(val) =>
                  handleChange(
                    val?.toUpperCase(),
                    field.label?.toLowerCase().replace(/\s+/g, "_")
                  )
                }
                disabled={mode === "view"}
                searchable={mode !== "edit" ? true : false}
                setSearchInput={(val) =>
                  // //(val)
                  handleSearch(
                    val?.toUpperCase(),
                    field.label?.toLowerCase().replace(/\s+/g, "_")
                  )
                }
                options={
                  options[field.label?.toLowerCase().replace(/\s+/g, "_")]
                }
                searchInput={
                  searchInput[field.label?.toLowerCase().replace(/\s+/g, "_")]
                }
                renderKey={
                  field.label !== "Medicine Name" ? "name" : "medicine_name"
                }
                handleSelectOption={(val) =>
                  handleSelectOption(
                    val,
                    field.label?.toLowerCase().replace(/\s+/g, "_")
                  )
                }
                add={true}
              />
            </div>
          );
        })}
      </div>
      <div className="cu-setup-medicine-form-btn-container">
        {mode !== "view" && (
          <button
            className={`cu-setup-medicine-form-btn cu-setup-medicine-form-save-btn`}
            type="submit"
          >
            {postMutation.isLoading ? <CuSpinner /> : "Save"}
          </button>
        )}
        {mode === "view" && (
          <button
            className={`cu-setup-medicine-form-btn cu-setup-medicine-form-save-btn`}
            type="submit"
            onClick={handleEdit}
          >
            Edit
          </button>
        )}
        <button
          className={`cu-setup-medicine-form-btn cu-setup-medicine-form-cancel-btn`}
          type="button"
          onClick={handleCancel}
        >
          Cancel
        </button>
      </div>
    </form>
  );
};

export default MedicineDataForm;
